<template>
    <v-container class="pa-4">
        <v-row>
            <v-col cols="12">

                <!-- Header -->
                <v-card class="rounded-xl elevation-2 px-4 py-3 mb-4">
                    <div class="d-flex align-center">
                        <v-btn icon small text color="primary" @click="chiudi">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                        <div class="ml-2 flex-grow-1">
                            <div class="text-subtitle-2 font-weight-bold primary--text">
                                Schema {{ discorso.diId }}
                            </div>
                        </div>
                        <v-icon color="primary" size="26">mdi-book-open-outline</v-icon>
                    </div>
                </v-card>

                <!-- Skeleton -->
                <v-card v-if="loading" class="rounded-xl elevation-2 pa-4">
                    <v-skeleton-loader type="list-item-two-line, list-item-two-line, actions" />
                </v-card>

                <!-- Form -->
                <v-card v-else class="rounded-xl elevation-2">
                    <v-card-text class="pt-5 pb-2 px-5">
                        <v-form v-model="valid" ref="formSchema">

                            <div class="field-label">Numero schema</div>
                            <v-text-field
                                :value="discorso.diId"
                                outlined rounded dense disabled
                                prepend-inner-icon="mdi-pound"
                                class="mb-4" />

                            <div class="field-label">Tema</div>
                            <v-text-field
                                v-model="discorso.tema"
                                outlined rounded dense
                                :rules="[v => !!v || 'campo obbligatorio']"
                                placeholder="Testo del tema"
                                prepend-inner-icon="mdi-text-box-outline"
                                class="mb-4" />

                            <div class="d-flex align-center px-1 mb-2">
                                <v-icon small color="grey darken-1" class="mr-3">mdi-eye-off-outline</v-icon>
                                <div class="flex-grow-1">
                                    <div class="text-body-2">Schema non disponibile</div>
                                    <div class="text-caption grey--text">Lo schema non verrà proposto durante la pianificazione</div>
                                </div>
                                <v-switch v-model="discorso.isOscurato"
                                    color="error" inset dense hide-details class="mt-0 pt-0" />
                            </div>

                        </v-form>
                    </v-card-text>

                    <v-divider />

                    <v-card-actions class="px-4 py-3">
                        <v-btn text rounded @click="chiudi">Annulla</v-btn>
                        <v-btn v-if="isSuperAdmin" text rounded small color="error"
                            @click="dialogElimina = true">
                            <v-icon small left>mdi-delete-outline</v-icon>
                            Elimina
                        </v-btn>
                        <v-spacer />
                        <v-btn color="primary" rounded depressed
                            :disabled="!valid" :loading="loadingSchema"
                            @click="save">
                            Salva
                        </v-btn>
                    </v-card-actions>
                </v-card>

            </v-col>
        </v-row>

        <!-- Dialog conferma eliminazione -->
        <v-dialog v-model="dialogElimina" max-width="360" persistent>
            <v-card class="rounded-xl">
                <v-card-title class="text-subtitle-1 font-weight-bold error--text pt-4 pb-2">
                    <v-icon color="error" class="mr-2">mdi-alert-outline</v-icon>
                    Elimina schema
                </v-card-title>
                <v-card-text class="text-body-2 pb-2">
                    Elimina lo schema <strong>{{ discorso.diId }}</strong> da tutte le circoscrizioni?<br/>
                    L'operazione è irreversibile.
                </v-card-text>
                <v-card-actions class="px-4 pb-4">
                    <v-btn text rounded @click="dialogElimina = false">Annulla</v-btn>
                    <v-spacer />
                    <v-btn color="error" rounded depressed :loading="loadingElimina" @click="eliminaSchema">
                        Elimina
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackSuccess" timeout="2000" color="success" bottom>
            <v-icon dark class="mr-2">mdi-checkbox-marked-circle</v-icon>
            Operazione eseguita con successo.
        </v-snackbar>
        <v-snackbar v-model="snackError" timeout="2000" color="error" bottom>
            <v-icon dark class="mr-2">mdi-alert-circle</v-icon>
            Errore durante l'esecuzione dell'operazione.
        </v-snackbar>
    </v-container>
</template>

<script>
import { callService, callPost, SUPERADMIN_CODE } from '@/modules/utilities.js'
import { VSkeletonLoader } from 'vuetify/lib'

export default {
    components: { VSkeletonLoader },
    props: {
        schemaId: { type: String, default: null },
    },
    data: () => ({
        discorso: {},
        valid: false,
        loading: false,
        loadingSchema: false,
        loadingElimina: false,
        dialogElimina: false,
        snackSuccess: false,
        snackError: false,
        SUPERADMIN_CODE: 0,
    }),
    computed: {
        effectiveId() {
            return this.schemaId || this.$route.params.id;
        },
        isSuperAdmin() {
            return this.$store.state.oratore.codice == this.SUPERADMIN_CODE;
        },
    },
    methods: {
        chiudi() {
            if (this.schemaId !== null) {
                this.$emit('close');
            } else {
                this.$router.back();
            }
        },
        async loadData() {
            this.loading = true;
            const schemiEstesi = await callService('/api/discorso/schemiEstesi', [this.$store.state.idCircoscrizione]);
            const found = schemiEstesi.find(se => se.discorso.id === this.effectiveId);
            if (found) {
                this.discorso = JSON.parse(JSON.stringify(found.discorso));
            }
            this.loading = false;
        },
        async save() {
            this.loadingSchema = true;
            const paramJson = {
                partition: this.$store.state.partition,
                username: this.$store.state.oratore.codice,
                token: this.$store.state.oratore.token,
                idCircoscrizione: this.$store.state.idCircoscrizione,
                discorso: this.discorso,
            };
            const discorso = await callPost('/api/discorso/saveDiscorso', paramJson);
            this.snackSuccess = !!discorso;
            this.snackError = !discorso;
            this.loadingSchema = false;
            if (discorso) {
                this.discorso = discorso;
                this.$root.$emit('schemi:aggiornati');
            }
        },
        async eliminaSchema() {
            this.loadingElimina = true;
            try {
                const paramJson = {
                    partition: this.$store.state.partition,
                    username: this.$store.state.oratore.codice,
                    token: this.$store.state.oratore.token,
                    diIds: [this.discorso.diId],
                };
                const res = await callPost('/api/discorso/EliminaDiscorso', paramJson);
                if (res) {
                    this.dialogElimina = false;
                    this.$root.$emit('schemi:aggiornati');
                    this.chiudi();
                } else {
                    this.snackError = true;
                    this.dialogElimina = false;
                }
            } catch {
                this.snackError = true;
                this.dialogElimina = false;
            } finally {
                this.loadingElimina = false;
            }
        },
    },
    async mounted() {
        this.SUPERADMIN_CODE = SUPERADMIN_CODE;
        if (this.schemaId !== null) await this.loadData();
    },
    async activated() {
        this.SUPERADMIN_CODE = SUPERADMIN_CODE;
        await this.loadData();
    },
}
</script>

<style scoped>
.field-label {
    font-size: 0.75rem;
    font-weight: 600;
    color: rgba(0,0,0,0.55);
    margin-bottom: 4px;
}
.theme--dark .field-label {
    color: rgba(255,255,255,0.5);
}
:deep(.v-text-field .v-input__prepend-inner .v-icon),
:deep(.v-text-field .v-input__append-inner .v-icon) {
    font-size: 16px !important;
    opacity: 0.55;
}
</style>
